import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Baby, Clock, Sparkles, HeartHandshake, Search, MapPin } from "lucide-react";
import { SERVICES } from "../mock";
import { useJobModal } from "../context/JobModalContext";

const ICONS = { Baby, Clock, Sparkles, HeartHandshake };

export default function SearchCard({ defaultLocation = "", citySlug = "" }) {
  const [active, setActive] = useState("nanny");
  const [location, setLocation] = useState(defaultLocation);
  const [description, setDescription] = useState("");
  const navigate = useNavigate();
  const { openJobModal } = useJobModal();
  const activeService = SERVICES.find((s) => s.id === active);

  const onSearch = (e) => {
    e.preventDefault();
    if (!location.trim()) {
      toast.error("Please enter a location to start your search.");
      return;
    }
    openJobModal({ service: active, location: location.trim(), citySlug, details: description.trim() });
  };

  return (
    <form onSubmit={onSearch} className="w-full rounded-2xl border border-black/10 bg-white shadow-[0_20px_50px_-20px_rgba(124,34,51,0.25)] p-5 sm:p-6">
      <p className="text-sm font-semibold text-[#1f1a1b] mb-3">What are you looking for?</p>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {SERVICES.map((s) => {
          const Icon = ICONS[s.icon];
          const isActive = active === s.id;
          return (
            <button
              type="button"
              key={s.id}
              onClick={() => setActive(s.id)}
              className={`flex flex-col items-center gap-1.5 rounded-xl border px-2 py-3 text-[13px] font-medium transition-all ${
                isActive
                  ? "border-[#7c2233] bg-[#f7e4e6] text-[#7c2233]"
                  : "border-black/10 text-[#5a5254] hover:border-[#7c2233]/40 hover:bg-[#faf1f2]"
              }`}
            >
              <Icon className="w-5 h-5" strokeWidth={1.6} />
              {s.label}
            </button>
          );
        })}
      </div>

      <p className="text-xs text-[#8a8285] mt-2.5">{activeService.note}</p>

      <div className="mt-4 relative">
        <MapPin className="w-4 h-4 text-[#8a8285] absolute left-3 top-1/2 -translate-y-1/2" />
        <input
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          placeholder="Location – e.g. New York"
          className="w-full h-12 rounded-xl border border-black/10 pl-9 pr-3 text-[15px] outline-none focus:border-[#7c2233] focus:ring-2 focus:ring-[#7c2233]/15 transition"
        />
      </div>

      <div className="mt-2.5">
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={2}
          placeholder="Briefly describe what you need – e.g. Mon–Fri afternoons for 2 kids…"
          className="w-full rounded-xl border border-black/10 px-3 py-2.5 text-[15px] outline-none focus:border-[#7c2233] focus:ring-2 focus:ring-[#7c2233]/15 transition resize-none"
        />
      </div>

      <button type="submit" className="w-full mt-2.5 h-12 inline-flex items-center justify-center gap-2 rounded-xl bg-[#7c2233] hover:bg-[#661b29] text-white font-medium px-6 shadow-sm transition-colors">
        <Search className="w-4 h-4" />
        Start search
      </button>

      <p className="text-xs text-[#8a8285] mt-3">
        Try {""}<span className="font-medium text-[#5a5254]">1 month free</span>, then only <span className="font-medium text-[#5a5254]">$15.99/month</span>. Cancel anytime.
      </p>

      <p className="text-[13px] text-[#8a8285] mt-3">
        Are you a caregiver?{" "}
        <button type="button" onClick={() => navigate("/auth?role=caregiver")} className="text-[#7c2233] font-medium hover:underline">Apply here</button>
        {" · "}
        <button type="button" onClick={() => navigate("/auth?role=caregiver")} className="text-[#7c2233] font-medium hover:underline">Browse jobs</button>
      </p>
    </form>
  );
}
